import React, { useState } from 'react';
import {
    Button,
    Grid,
    Paper,
    TextField,
    Box,
    Typography,
    Link
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useNavigate } from 'react-router-dom';
import { decodeJWT, getToken } from '../../utils/utils';
import { changePassword } from './api';
const ResetLink: React.FC = () => {


     const navigate = useNavigate();
     const token = getToken();
          const decodedToken = decodeJWT(token);
          console.log(decodedToken, "Decoded token");
                const mainemail = decodedToken?.email;
    const [email, setEmail] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const validateEmail = (value: string) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        return regex.test(value);
    };

    const isError = isSubmitted && !validateEmail(email);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
        setIsSuccess(false); // Reset success on change
    };

    const handleSubmit = () => {
        setIsSubmitted(true);
        if (validateEmail(email)) {
            console.log("Reset link sent to:", email);
            setIsSuccess(true);
        } else {
            setIsSuccess(false);
        }
    };
const handleChangess = async (e: React.MouseEvent<HTMLAnchorElement>) => {
  e.preventDefault();
  console.log("Resend link clicked");

  try {
const response = await changePassword({ email: mainemail }, token);
    console.log("Resend response:", response);
  } catch (error) {
    console.error("Error resending link:", error);
  }
};

    return (
        <Grid container component="main" sx={{ height: '100vh' }}>
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <Box
                    sx={{
                        my: 8,
                        mx: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <img src="/logo-pmi.png" alt='logo' />

                    <Box sx={{ mt: 8, textAlign: "left", width: '440px' }}>
                        <Typography variant="h5" fontWeight="bold" fontSize="30px" color="#282829" gutterBottom>
                            Reset link sent!
                        </Typography>
                        <Typography variant="body1" mb={3} fontSize="16px" color="#282829" fontWeight="500">
                            The password reset link has been sent successfully to your registered mail id - <b>{mainemail}</b>
                        </Typography>

                        <Box display="flex" alignItems="left" mt={2}>
                            <Typography variant="body2" sx={{ paddingTop: "2px" }} color="textPrimary">
                                Didn’t receive the reset link yet?
                            </Typography>
                             <Link
      href="#"
      onClick={handleChangess}
      underline="none"
      sx={{ color: '#C8172F', fontWeight: 500, ml: 1 }}
    >
      Resend Link
    </Link>
                        </Box>


                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};

export default ResetLink;
